export enum ChartType {
  Distribution = 0,
  Trend = 1,
  Comparison360 = 2,
  Table = 3,
  Spider = 4,
  Colorful = 5,
}
